export default __webpack_public_path__ + "static/media/background_line.7bfb1f06.svg";